import { readHexInt } from "./hex";
import { getProtocolString } from "./source";

const FILTER_DEFINITIONS = [
  { key: "softeningResin", name: "软化树脂", offset: 2 },
  { key: "activatedCarbon", name: "活性炭", offset: 22 },
  { key: "quartzSand", name: "石英砂", offset: 42 },
  { key: "precisionFilter", name: "精密滤芯", offset: 62 },
  { key: "regenerationSalt", name: "再生盐", offset: 82 },
  { key: "roMembrane", name: "RO/NF膜", offset: 102 }
];

export const CONSUMABLE_DISPLAY_ORDER = [
  "quartzSand",
  "activatedCarbon",
  "softeningResin",
  "precisionFilter",
  "roMembrane",
  "regenerationSalt"
];

function parseFilterRecord(filter, definition) {
  const offset = definition.offset;
  const settingFlowRaw = readHexInt(filter, offset, 4);
  return Object.assign({}, definition, {
    // The settings dialog edits the protocol value itself; the dashboard uses
    // the corresponding actual volume in m³ (protocol value × 10).
    settingFlowRaw,
    settingFlow: settingFlowRaw * 10,
    usedFlow: readHexInt(filter, offset + 4, 8) * 0.1,
    settingDays: readHexInt(filter, offset + 12, 4),
    usedDays: readHexInt(filter, offset + 16, 4)
  });
}

export function parseFilterRecords(protocol) {
  const filter = getProtocolString(protocol, "filter");
  return FILTER_DEFINITIONS.map(definition =>
    parseFilterRecord(filter, definition)
  );
}

export function parseFilterRecordByKey(protocol, key) {
  const definition = FILTER_DEFINITIONS.find(item => item.key === key);
  if (!definition) {
    return null;
  }

  return parseFilterRecord(getProtocolString(protocol, "filter"), definition);
}
